import Vue from 'vue'
import { logger } from './logger'
const Rollbar = require('vue-rollbar')
const isIE = () => {
  const ua = navigator.userAgent
  return ua.indexOf('MSIE') > -1 || ua.indexOf('Trident') > -1
  // https://attacomsian.com/blog/javascript-dom-detect-internet-explorer-browser
}

const IGNORED_DOMAINS = ['relohotels', 'rio-hotels', 'mimaruhotels', 'accor-resorts-japan']
const IGNORED_FACILITY_CODES = [
  'f2e0ef1a-590f-4ddf-a691-e5dd680b067e',
  '6343dc8f-a239-479b-8639-9168a063bbaa'
]
const IGNORED_MESSAGES = [
  '.*Navigation cancelled.*',
  '.*Failed to fetch.*',
  '.*Load failed.*',
  '.*Avoided redundant navigation.*'
]

const isIgnoredDomain = IGNORED_DOMAINS.some?.((domain) =>
  window.location.hostname.toLowerCase?.()?.includes?.(domain)
)
const isIgnoredFacilityCode = IGNORED_FACILITY_CODES.some?.((code) =>
  window.location.search?.toLowerCase?.()?.includes?.(code)
)

Vue.use(Rollbar, {
  accessToken: process.env.ROLLBAR_TOKEN,
  captureUncaught: false,
  captureUnhandledRejections: true,
  enabled:
    (process.env.NODE_ENV === 'production' || TARGET_ENV === 'staging' || TARGET_ENV === 'qa') &&
    !isIE() &&
    !isIgnoredDomain &&
    !isIgnoredFacilityCode,
  ignoredMessages: IGNORED_MESSAGES,
  environment: TARGET_ENV,
  captureIp: true,
  payload: {
    client: {
      javascript: {
        code_version: COMMIT_HASH,
        source_map_enabled: true,
        guess_uncaught_frames: true
      }
    }
  }
})

if (process.env.NODE_ENV === 'production') {
  Vue.config.errorHandler = (err, _vm, _info) => {
    // err: error trace
    // vm: component in which error occured
    // info: Vue specific error information such as lifecycle hooks, events etc.
    logger.error(err)
  }

  // way too noisy

  // window.onerror = function (message, source, lineno, colno, error) {
  //   if (error) {
  //     logger.errorFromString(
  //       `Source: ${source}, line:${lineno}, column:${colno}, Message: ${message}`
  //     )
  //     logger.error(error)
  //   } else {
  //     logger.errorFromString(
  //       `Error: ${error}. Message: ${message}. Source: ${source}, line:${lineno}, column:${colno}`
  //     )
  //   }
  // }
}

Vue.prototype.$logger = logger
